import { useState } from 'react';
import Tabs from '@/components/Tabs';
import useFeatureView from '@/hooks/useFeatureView';
import PayrollTab from '@/modules/payroll/components/PayrollTab';
import PayRunReadinessTab from '@/modules/payroll/components/PayRunReadinessTab';
import {
  getPayrollTabs,
  getPayrollView,
  type PayrollTabKey,
} from '@/modules/payroll/views/payroll.view';

const PayrollPage = () => {
  const view = useFeatureView(getPayrollView);
  const payrollTabs = getPayrollTabs(view.tabs);
  const [selectedTab, setSelectedTab] = useState<PayrollTabKey | undefined>(
    view.defaultTab,
  );

  return (
    <div className="flex h-full flex-col p-4">
      <div className="mb-4 flex flex-col gap-2">
        <h1 className="text-2xl font-bold text-gray-900">Pay Run</h1>
      </div>

      {payrollTabs.length === 0 || !selectedTab ? (
        <div className="rounded-lg border bg-white p-6 text-sm text-gray-600">
          You don&apos;t have access to any payroll views.
        </div>
      ) : (
        <Tabs
          tabs={payrollTabs}
          selectedTabKey={selectedTab}
          onTabChange={(key) => setSelectedTab(key as PayrollTabKey)}
        >
          {selectedTab === 'payRunReadiness' && (
            <PayRunReadinessTab view={view} />
          )}
          {selectedTab === 'payroll' && <PayrollTab view={view} />}
        </Tabs>
      )}
    </div>
  );
};

export default PayrollPage;
